import { FormField } from './form-field'

interface ColorPickerFieldProps {
  label: string
  value: string
  onChange: (value: string) => void
  error?: string
}

export function ColorPickerField({ label, value, onChange, error }: ColorPickerFieldProps) {
  return (
    <FormField label={label} error={error}>
      <div className="flex items-center gap-3">
        <input
          type="color"
          value={value || '#000000'}
          onChange={(e) => onChange(e.target.value)}
          className="h-10 w-10 cursor-pointer rounded-lg border border-neutral-300 p-0.5"
        />
        <input
          type="text"
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          placeholder="#000000"
          className="h-10 w-32 rounded-lg border border-neutral-300 bg-neutral-50 px-3 text-sm transition-colors hover:border-neutral-400 focus:border-primary focus:bg-white focus:outline-none focus:ring-2 focus:ring-primary/25"
        />
      </div>
    </FormField>
  )
}
